// extracted by mini-css-extract-plugin
module.exports = {"country-card":"style_country-card__2Y6Wa","flag":"style_flag__1ipkW","country-link":"style_country-link__jJwEt","go-cta":"style_go-cta__mnbQZ","country":"style_country__bUUxe"};